export default __webpack_public_path__ + "static/media/message-bubbles.436e35c7.svg";